const projectStatuses = {
  'new': 'New',
  'in_progress': 'In progress',
  'exec_ready': 'Ready for execution',
  'executed': 'Executed',
  'res_generated': 'Results generated',
  'published': 'Published'
};

export default projectStatuses;